import { SimpleSizingPanelState } from 'utils/is-simple-sizing-panel-types';
import { isBasicSizingSystemPreference } from 'utils/project';

export function isSimpleSizingPanelState(
  state: SimpleSizingPanelState
): boolean {
  return (
    isBasicSizingSystemPreference(state.systemPreference) &&
    state.activeStructureStepId === 'confirm_details'
  );
}
